import { Button } from "@adfenix/alexandria";
import { useContext } from "react";

import { ReadLayerContext } from "./ReadLayerQueryContext";
import { useTranslation } from "react-i18next";
interface ResetButtonProps {
  text?: string;
}

export const ResetButton = ({ text }: ResetButtonProps) => {
  const ctx = useContext(ReadLayerContext);
  const { t } = useTranslation();

  if (!ctx) return null;

  const { reset } = ctx;
  return text ? (
    <Button logLabel="readlayer-reset-button" variant="primary" onClick={reset}>
      {/* order translations */}
      {text}
    </Button>
  ) : (
    <Button
      logLabel="readlayer-reset-button"
      variant="secondary"
      onClick={reset}
    >
      {t("readLayer.filters.reset.button.text")}
    </Button>
  );
};
